import { AppMarketApiService } from './service';
import ApiClientFactory from '../../api/client-factory';

const service = new AppMarketApiService(ApiClientFactory());

export function AppMarketApiServiceFactory(): typeof service {
  return service;
}
